import { Link } from 'react-router-dom';

export default function HeroBanner() {
  return (
    <section className="relative w-full min-h-[480px] md:min-h-[580px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=artistic%20abstract%20manga%20comic%20style%20background%20with%20warm%20orange%20and%20coral%20gradient%20geometric%20shapes%20overlapping%20panels%20Japanese%20wave%20patterns%20subtle%20ink%20wash%20texture%20modern%20clean%20aesthetic%20minimal%20composition%20digital%20art&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="星星动漫网背景图"
        className="absolute inset-0 w-full h-full object-cover object-center"
        title="星星动漫网 - 韩漫日漫国漫漫画大全"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[1440px] mx-auto px-4 md:px-6 text-center py-16">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">
          好看的漫画
          <span className="block mt-2">从这里开始</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇集韩漫、日漫、国漫等各类漫画作品，免费全集在线观看。按地区分类，轻松找到你喜欢的漫画，高清画质下拉式阅读体验。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/kr"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3 rounded-full border border-white/30 text-white font-medium text-sm hover:bg-white/10 transition-colors cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 flex items-center justify-center gap-8 md:gap-12">
          {[
            { num: '10万+', label: '漫画作品' },
            { num: '500万+', label: '活跃读者' },
            { num: '99.9%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.num}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}